import type { ResearchAnswer } from '@buakei/types';
import { LEARNING_PROMPTS, PROFESSIONAL_PROMPTS, type ScriptedPrompt } from '@/demo/answers';
import { demoResponse } from './demo-runtime';

export type AssistantReply =
  { kind: 'answer'; answer: ResearchAnswer } | { kind: 'notice'; text: string };

export type AssistantRequest = { promptId: string } | { text: string };

/** Contract for the orchestrated assistant (M4). The demo never calls an AI provider (ADR-004 C). */
export interface AssistantService {
  prompts: readonly ScriptedPrompt[];
  ask(request: AssistantRequest): Promise<AssistantReply>;
}

const NOT_CONNECTED =
  'Live AI research is not connected in this demo. Choose one of the sample questions to see how sourced answers, citations and coverage will be presented.';

function scripted(prompts: readonly ScriptedPrompt[]): AssistantService {
  return {
    prompts,
    ask: (request) => {
      const match =
        'promptId' in request ? prompts.find((p) => p.id === request.promptId) : undefined;
      const reply: AssistantReply = match
        ? { kind: 'answer', answer: match.answer }
        : { kind: 'notice', text: NOT_CONNECTED };
      return demoResponse(reply, { kind: 'notice', text: NOT_CONNECTED });
    },
  };
}

export const demoResearchAssistant = scripted(PROFESSIONAL_PROMPTS);
export const demoTutorAssistant = scripted(LEARNING_PROMPTS);
